import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getColorByResponse } from 'services/colorService'; // Certifique-se de que esta importação está correta

const Legenda = ({ legendData, selectedUF, currentColor }) => {
    const filteredLegendData = legendData.filter(item => !selectedUF || item.sigla_uf === selectedUF);

    const totalItems = filteredLegendData.reduce((total, item) => total + 1, 0);

    return (
        <div className="legenda" style={{ backgroundColor: 'rgba(83, 108, 149, 0.5)', padding: '1em', borderRadius: '8px' }}>
            <p>Nível dos problemas relacionados <br /> ao consumo de crack</p>
            <ul style={{ listStyleType: 'none', padding: 0 }}>
                {filteredLegendData
                    .filter(item => item.resposta !== '')
                    .reduce((acc, curr) => {
                        if (!acc.find(item => item.resposta === curr.resposta)) {
                            acc.push(curr);
                        }
                        return acc;
                    }, [])
                    .sort((a, b) => a.resposta.localeCompare(b.resposta))
                    .map((item, index) => {
                        const itemCount = filteredLegendData.filter(data => data.resposta === item.resposta).length;
                        const color = getColorByResponse(item.resposta); // Usando a função para obter a cor

                        if (itemCount > 0) {
                            return (
                                <li key={index} style={{ backgroundColor: color, color: '#fff', position: 'relative' }}>
                                    {currentColor === color && <ArrowBackIcon style={{ position: 'absolute', right: '-20px', top: '50%', transform: 'translateY(-50%)', color: 'red' }} />}
                                    {item.resposta} ({itemCount})
                                </li>
                            );
                        } else {
                            return null;
                        }
                    })}
                <li style={{ backgroundColor: 'var(--branco)', color: 'var(--preto)' }}> Total ({totalItems})</li>
            </ul>
        </div>
    );
};

export default Legenda;
